import React, { type FC } from "react";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import type { IconVariantTypes } from "../../../../../../shared-components/css-modules/lexus/atoms/Icon.types";
import styles from "./WheelEcoLabel.module.scss";
import a11y from "../../../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import { useUniqueId } from "../../../../../../../../common-deprecated/hooks";
import { useCarConfigLabel } from "../../../../../utils/labelUtils";
import type { CarConfigLabelType } from "../../../../../utils/labels";

type LabelProps = {
    type: IconVariantTypes;
    score: string;
};

const WheelEcoLabel: FC<LabelProps> = ({ type, score }) => {
    const a11yLabel = useCarConfigLabel(`carConfig${type}` as CarConfigLabelType);
    const labeledById = useUniqueId();

    if (score === "") return null;
    return (
        <div className={styles.label} aria-labelledby={labeledById}>
            <Icon variant={type as IconVariantTypes} sizing="sm" className={styles.icon} aria-hidden />
            <span className={a11y["sr-only"]} id={labeledById}>
                {a11yLabel}
            </span>
            <span className={styles.score} data-score={score}>
                {score}
            </span>
        </div>
    );
};

export default WheelEcoLabel;
